import * as React from 'react'

import { HorizontalAlignment } from '@thg-commerce/enterprise-core'

import {
  StyledImage,
  StyledImageHover,
  LogoText,
  StyledLink,
  LogoImageContainer,
} from './styles'

export interface LogoProps {
  title?: string
  link?: string
  horizontalAlignment?: HorizontalAlignment
  image: {
    src: string
    onHoverSrc?: string
    alt?: string
  }
  widgetIndex: number
}

export const LogoImage = (props: LogoProps) => {
  const image = (
    <LogoImageContainer hasHoverItem={!!props.image?.onHoverSrc}>
      <StyledImage
        loading={props.widgetIndex > 1 ? 'lazy' : 'eager'}
        src={props.image.src}
        alt={props.image.alt || ''}
      />
      {props.image?.onHoverSrc && (
        <StyledImageHover
          src={props.image.onHoverSrc}
          alt={props.image.alt || ''}
          loading="lazy"
        />
      )}
      {props?.title && (
        <LogoText horizontalAlignment={props.horizontalAlignment}>
          {props.title}
        </LogoText>
      )}
    </LogoImageContainer>
  )

  return props?.link ? (
    <StyledLink
      aria-label={props?.title || props.image?.alt || null}
      href={props.link}
    >
      {image}
    </StyledLink>
  ) : (
    image
  )
}
